<template>

    <div class="ES-xcx-info top10">
    <wcbutton 
        :option="{title:'添加导航'}" 
        @finish="(val)=> {
            if(navlists.length==limit) {
                $notice({title:'消息提示',message:'添加分类数量不能超过'+limit,type:'warning'});
                return false;
            }else {
                var datainfo={};
                for(var i in navinfo) datainfo[i]=navinfo[i];
                navlists.push(datainfo);
            }
        }"
    />
    </div>
    <div class="TTL-table top30" :ref="objloading">
    <el-table :data="navlists" stripe="true" empty-text="" >
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column label="导航名称" align="center">
            <template #default="scope">
            <wcselect :option="{placeholder:'请选择分类',ischange:true,width:'150px',filterable:true}" 
                class="uploadImg" 
                :value="scope.row.infoid"
                :list="childnavlists"
                @finish="(val)=> {
                    scope.row.infoid=val.value;
                    scope.row.name=val.valuename;
                    Updatenav(scope.$index);
                }"
            />
            </template>
        </el-table-column>
        <el-table-column label="排序" align="center">
            <template #default="scope">
            <wcinput :option="{placeholder:'排序',type:'input',width:'80px',ischange:true,isinput:true}" 
                class="uploadImg"
                :value="scope.row.sort"
                @finish="(val) => {
                    if(val.type=='change') {
                        scope.row.sort=val.value;
                        Updatenav(scope.$index);
                    }
                }"
            />
            </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
            <template #default="scope">
                <wcbutton :option="{title:'删除',type:'del'}" 
                    @finish="(val)=> {
                        var id=scope.row.id;
                        navlists.splice(scope.$index,1);
                        Delnav(id);
                    }"
                />
            </template>
        </el-table-column>
    </el-table>
    </div>

</template>

<script>
import INTERFACE_XCX from '@/Interface/Es/xcx'; //小程序首页显示
export default {
    components:{INTERFACE_XCX},

    data() {
        return {
            objloading:'xcxnav',
            limit:10,
            navinfo: {id:'',name:'',infoid:'',sort:0},
            navlists: [],
            childnavlists:[],
        }
    },

    mounted() {
        this.GetChildcates(); //获取二级分类信息
        this.CateInfo();
    },

    methods: {
        
        //获取分类信息
        CateInfo() {
            INTERFACE_XCX.GET_NAV_LIST().then((res) => {
                 if(res.status > 0) return false;
                 this.navlists=res.data;
            });
        },

        /** 更新banner信息 **/
        Updatenav(index) {
            var navinfo=this.navlists[index];
            var METHOD=navinfo.id > 0 ? 'UPDATE_NAV' : 'ADD_NAV';
            INTERFACE_XCX[METHOD](navinfo).then((res) => {
                 if(res.status > 0) return false;
                 if(METHOD=='ADD_NAV') navinfo.id=res.data.id;
                 this.navlists=this.$method.DATA_SORT(this.navlists,{sort:'desc'});
                 this.$emit('finish',{data:this.navlists});
            });
        },

        /** 删除广告 **/
        Delnav(id) {
            INTERFACE_XCX.DEL_NAV({id:id}).then((res) => {
                 if(res.status > 0) return false;
                 this.navlists=this.$method.DATA_SORT(this.navlists,{sort:'desc'});
                 this.$emit('finish',{data:this.navlists});
            });
        },

        //获取二级分类信息
        GetChildcates() {
            this.$method.GET_CATES_CHILD(true).then((res) => {this.childnavlists=res;console.log(res)});
        },

    },
    
}
</script>
<style scoped>
.ES-xcx-info {display: inline-flex;align-items: center;width:100%;justify-content: flex-end;}
.uploadImg {display:inline-flex;justify-content:center;align-items: center;}
.ES-notice {font-size:12px;color:#333333;margin-top:20px;}
::v-deep(.TTL-input .el-input__inner) {text-align: center;}
::v-deep(.TTL-select .el-input__inner) {text-align: center;}
</style>